export default __webpack_public_path__ + "static/export-document-823464848a23c798043004f00d889cd8.jpeg";